import paletteKeys from '../../generated/json/palette/palette-keys.json';
export const avatarBackgroundColors = paletteKeys.filter(x => x.startsWith('avatar-')).sort((a, b) => Number(a.split('-')[1]) - Number(b.split('-')[1]));
export type avatarBackgroundColor = (typeof avatarBackgroundColors)[number];